/** Contexts — edit view (delegates to the shared ContextForm). */
import { ContextForm } from "./_ContextForm";

export function ContextEdit() {
  return <ContextForm action="edit" />;
}

export default ContextEdit;
